import React from 'react';

import {
  ResponsiveContainer,
  LineChart,
  Line,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  Legend,
} from 'recharts';

import moment from 'moment';

export default ({
  id,
  title,
  data,
  XAxisDataKey,
  Lines,
  domain,
  yGraphDomain,
  yTicks = null,
}) => {
  const graphDomain = domain || ['auto', 'auto'];
  const yDomain = yGraphDomain || ['auto', 'auto'];
  return (
    <div className="station-profile-chart  wrap-collabsible">
      <input id={id} className="toggle" type="checkbox" defaultChecked />
      <label htmlFor={id} className="collapsible-toggle">
        <h3 className="title is-h3 is-inline-block">{title}</h3>
      </label>
      <div className="collapsible-content">
        <ResponsiveContainer width="100%" height={300}>
          <LineChart
            data={data}
            margin={{
              top: 5,
              right: 30,
              left: 20,
              bottom: 5,
            }}
          >
            <CartesianGrid strokeDasharray="3 3" />
            <XAxis
              dataKey={XAxisDataKey}
              type="number"
              scale="time"
              domain={graphDomain}
              allowDataOverflow
              interval="preserveStartEnd"
              tickFormatter={(unixTime) => moment.utc(unixTime).format('HH:mm')}
            />
            <YAxis domain={yDomain} ticks={yTicks} allowDataOverflow />
            <Tooltip
              labelFormatter={(value) => {
                const date = moment.utc(value).format('DD/MM HH:mm:ss');
                return date;
              }}
            />
            <Legend verticalAlign="top" />

            {Lines.map((line) => {
              const { dataKey, stroke = '#8884d8' } = line;
              return (
                <Line
                  key={dataKey}
                  type="linear"
                  dataKey={dataKey}
                  stroke={stroke}
                  dot={false}
                />
              );
            })}
          </LineChart>
        </ResponsiveContainer>
      </div>
    </div>
  );
};
